import { createSlice } from "@reduxjs/toolkit";
import { getDashboardData } from "./_dashboardAction";

const initialState: any = {
  data: [],
  isLoading: true,
  isSuccess: false,
  responseCode: null,
  responseMessage: '',
  totalRecord: 0,
};

export const dashboardData = createSlice({
  name: "dashboard",
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getDashboardData.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
      })
      .addCase(getDashboardData.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.data = payload.data||[];
        state.responseMessage = payload.responseMessage
        state.responseCode = payload.responseCode
        state.totalRecord = payload.totalRecord || 0
      })
      .addCase(getDashboardData.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.errorMessage = payload;
      })
  },
});
